export interface ServiceDetail {
  id: string;
  title: string;
  shortDescription: string;
  fullDescription: string;
  features: string[];
  imageGallery?: string[];
  seo?: {
    keywords: string[];
    image?: string; // main image for OG/Twitter preview
  };
}

export const servicesData: ServiceDetail[] = [
  {
    id: "immigration-services",
    title: "Immigration, Visa & Work Permit Services",
    shortDescription: "Fast, reliable, and compliant immigration solutions",
    fullDescription:
      "Northstart Systems provides reliable and efficient support for individuals and organizations navigating Kenya's immigration and labor requirements. Our services are designed to simplify complex procedures and ensure compliance with all government regulations.",
    features: [
      "Visa Processing (Short & Long Term)",
      "Work Permit Applications & Renewals",
      "Dependent, Student & Special Passes",
      "Residency & Citizenship Guidance",
      "Corporate Immigration Compliance Support",
      "Document Preparation & Verification",
      "Application Tracking & Follow-up",
      "End-to-End Assistance from Filing to Approval",
    ],
    imageGallery: [
      "/images/immigration/1.jpeg",
      "/images/immigration/2.jpeg",
      "/images/immigration/3.jpeg",
      "/images/immigration/4.jpeg",
      "/images/immigration/5.jpeg",
      "/images/immigration/6.jpeg",
    ],
    seo: {
      keywords: [
        "visa services kenya",
        "work permit kenya",
        "immigration services nairobi",
        "visa processing kenya",
        "work permit application kenya",
        "residency permit kenya",
        "corporate immigration kenya",
        "dependent pass kenya",
      ],
      image: "/images/immigration/1.jpeg",
    },
  },
  {
    id: "development",
    title: "Development Solutions",
    shortDescription: "Web, App & Custom Software Development",
    fullDescription:
      "End-to-end development services including modern web applications, mobile apps, and custom software tailored to your business goals.",
    features: [
      "Web Design & Development",
      "Mobile App Development",
      "Custom Software Solutions",
      "E-commerce Platforms",
      "API Integration",
      "Ongoing Maintenance",
    ],
    imageGallery: [
      "/images/webdev/1.jpeg",
      "/images/webdev/2.jpeg",
      "/images/webdev/3.jpeg",
      "/images/webdev/4.jpeg",
    ],
    seo: {
      keywords: [
        "web development kenya",
        "app development kenya",
        "custom software solutions",
        "ecommerce platforms kenya",
        "business software integration",
      ],
      image: "/images/webdev/1.jpeg",
    },
  },
  {
    id: "e-procurement",
    title: "E-Procurement System Solutions",
    shortDescription: "Streamlined procurement systems",
    fullDescription:
      "Transform your procurement process with our comprehensive e-procurement solutions.",
    features: [
      "Supplier Management",
      "Tender Management",
      "Purchase Order Automation",
      "Invoice Processing",
      "Compliance Tracking",
      "Reporting & Analytics",
    ],
    imageGallery: [
      "/images/eproc/1.jpeg",
      "/images/eproc/2.jpeg",
      "/images/eproc/3.jpeg",
      "/images/eproc/4.jpeg",
    ],
    seo: {
      keywords: [
        "e-procurement kenya",
        "digital procurement systems",
        "supplier management software",
        "tender management kenya",
      ],
      image: "/images/eproc/1.jpeg",
    },
  },
  {
    id: "security-solutions",
    title: "Security Solutions",
    shortDescription: "CCTV and security installations",
    fullDescription:
      "Comprehensive security solutions including CCTV systems and access control.",
    features: [
      "CCTV Camera Systems",
      "Access Control Systems",
      "Walkthrough Metal Detectors",
      "Perimeter Fencing",
      "Alarm Systems",
      "Remote Monitoring",
    ],
    imageGallery: [
      "/images/security/1.jpeg",
      "/images/security/2.jpeg",
      "/images/security/3.jpeg",
      "/images/security/4.jpeg",
    ],
    seo: {
      keywords: [
        "CCTV kenya",
        "security installations",
        "access control systems",
        "alarm systems nairobi",
        "remote monitoring solutions",
      ],
      image: "/images/security/1.jpeg",
    },
  },
  {
    id: "ict-systems-support",
    title: "ICT Systems & Support",
    shortDescription: "Complete ICT infrastructure & reliable support",
    fullDescription:
      "From hardware procurement to cloud backup, our ICT Systems & Support solutions ensure your business runs smoothly and securely.",
    features: [
      "Hardware Procurement",
      "Software Licensing",
      "System Integration",
      "Network Setup",
      "Server Installation",
      "Cloud Backup & Data Recovery",
      "Help Desk & Remote Assistance",
      "Preventive Maintenance",
    ],
    imageGallery: [
      "/images/ict/1.jpeg",
      "/images/ict/2.jpeg",
      "/images/it/1.jpeg",
      "/images/it/2.jpeg",
    ],
    seo: {
      keywords: [
        "ICT systems kenya",
        "IT support kenya",
        "network setup nairobi",
        "server installation kenya",
        "cloud backup kenya",
        "technical support nairobi",
      ],
      image: "/images/ict/1.jpeg",
    },
  },
  {
    id: "consultancy",
    title: "Consultancy Services",
    shortDescription: "Strategic ICT consultancy & partnerships",
    fullDescription:
      "We provide consultancy and strategic representation for ICT brands in the Kenyan market, helping businesses grow and expand.",
    features: [
      "Market Analysis",
      "Partner Identification",
      "Contract Negotiation",
      "Marketing Support",
      "Sales Channel Development",
      "Market Expansion Strategy",
    ],
    imageGallery: [
      "/images/agency/1.jpeg",
      "/images/agency/2.jpeg",
      "/images/agency/3.jpeg",
    ],
    seo: {
      keywords: [
        "ICT consultancy kenya",
        "technology partnerships",
        "ict brand representation",
        "market expansion kenya",
        "ict partnerships africa",
      ],
      image: "/images/agency/1.jpeg",
    },
  },
];
